(function () {
  const ANCHOR = 'div[class="d-flex flex-column align-items-end align-self-end"]';
  const WIDGET = '.vfr__container';
  const MOBILE_CONTAINER = '[data-sizebay-mobile]';

  function desktopLayout() {
    const variants = document.querySelector('.variants');
    return !!variants && getComputedStyle(variants).display !== 'none';
  }

  function moveTo(container) {
    if (!container || desktopLayout()) return false;
    const widget = document.querySelector(WIDGET);
    if (!widget || container.contains(widget)) return false;
    container.appendChild(widget);
    return true;
  }

  function init() {
    const offcanvas = document.querySelector('variant-selector-mobile');
    if (!offcanvas) return;
    const move = () => moveTo(offcanvas.querySelector(MOBILE_CONTAINER));
    move();
    new MutationObserver(move).observe(offcanvas, { childList: true, subtree: true });
    const anchor = document.querySelector(ANCHOR);
    if (anchor) new MutationObserver(move).observe(anchor, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
